(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/start/assets/react/components/start-header.js') >= 0) return;  svs.modules.push('/modules/lotto/components/start/assets/react/components/start-header.js');

'use strict';

var _svs$lotto$data$cms;
const lottoStartPageInfo = (_svs$lotto$data$cms = svs.lotto.data.cms) === null || _svs$lotto$data$cms === void 0 ? void 0 : _svs$lotto$data$cms.lottoStartPageInfo;
const {
  CmsTextFormatter
} = svs.lotto.react.components;
const StartHeader = () => React.createElement("h1", {
  className: "start-header js-start-header"
}, React.createElement(CmsTextFormatter, {
  text: lottoStartPageInfo === null || lottoStartPageInfo === void 0 ? void 0 : lottoStartPageInfo.textTitle
}));
setGlobal('svs.lotto.react.components', {
  StartHeader
});

 })(window);